export default __webpack_public_path__ + "static/media/topicListingFit.8cdbc3f1.png";